(() => {
  if (window.velvetContactReady) return;
  window.velvetContactReady = true;
  const setup = root => {
    root.querySelectorAll('.contact-page').forEach(page => {
      const message = page.querySelector('#ContactMessage');
      const count = page.querySelector('[data-message-count]');
      if (message && count && !message.dataset.countReady) {
        message.dataset.countReady = 'true';
        const update = () => { count.textContent = String(message.value.length); };
        message.addEventListener('input', update); update();
      }
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('.path-select');
    if (!button) return;
    const topic = document.querySelector('#ContactTopic');
    const form = document.querySelector('#contact-form');
    if (topic) topic.value = button.dataset.topic || '';
    form?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.setTimeout(() => topic?.focus(), 500);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document)); else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
